<ion-header [translucent]="false" class="ion-no-border custom-header" mode="md">
  <ion-toolbar>
    <ion-title class="modal-title" *ngIf="modalType=='rename' || modalType=='save'">{{'save_configuration' | translate}}</ion-title>
    <ion-title class="modal-title" *ngIf="modalType=='delete'">{{'delete_configuration' | translate}}</ion-title>
    <ion-title class="modal-title" *ngIf="modalType=='requiredLogin'">{{'login_required' | translate}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="close()">
        <ion-icon name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>
<ion-content [fullscreen]="true" class="ion-padding">
  <div class="configuration-container">
    <div *ngIf="modalType=='rename' || modalType=='save'">
      <div class="select-group">
        <ion-label class="input-label">{{'configuration_name' | translate}}</ion-label>
        <ion-input class="bordered-input" type="text"  [(ngModel)]="eConfigName" name="eConfigName"
          (ionInput)="validateForm()" (ionBlur)="validateForm()">
        </ion-input>
      </div>

      <ion-chip color="warning" class="customChip warningClass" *ngIf="isNameExist">
        <ion-icon name="warning-outline" color="warning"></ion-icon>
        <ion-label>
          <div class="chip-content">
            <div class="chip-title">{{'name_already_used' | translate}}</div>
            <div class="chip-description">{{'configname_already_exist' | translate}}</div>
          </div>
        </ion-label>
      </ion-chip>
      <p *ngIf="isNameExist">{{'save_confirmation' | translate}}</p>
    </div>

    <div *ngIf="modalType=='delete'">
      <p>{{'delete_confirmation' | translate}}</p>
    </div>

    <div *ngIf="modalType=='requiredLogin'">

      <p>{{'need_to_login' | translate}}</p>

      <!-- Basic Chip -->
      <ion-chip color="primary" class="customChip primaryClass">
        <ion-icon name="information-circle-outline" color="primary"></ion-icon>
        <ion-label>
          <div class="chip-content">
            <div class="chip-title"></div>
            <div class="chip-description">{{'config_will_not_lost' | translate}}</div>
          </div>
        </ion-label>
      </ion-chip>
      <p>{{'confirm_login_message' | translate}}</p>
    </div>
  </div>
</ion-content>

<ion-footer [translucent]="false" class="ion-no-border ">
  <div class="button-container">
    <ion-button fill="outline" class="cancel-btn" (click)="cancel()" expand="block">
      {{'cancel' | translate}}
    </ion-button>
    <ion-button class="next-btn" (click)="next()" expand="block" *ngIf="modalType=='rename' || modalType=='save'">
    {{ (isNameExist ? 'confirm' : 'save') | translate }}
    </ion-button>
    <ion-button class="next-btn" (click)="login()" expand="block" *ngIf="modalType=='requiredLogin'">
      {{'login' | translate}}
    </ion-button>
    <ion-button class="delete-btn" (click)="delete()" expand="block" *ngIf="modalType=='delete'">
      {{'delete' | translate}}
    </ion-button>
  </div>
</ion-footer>